import { Text } from '@bbl-digital/snorre'
import { IconErrorOutline } from '@bbl-digital/snorre-v2'
import { useTheme } from '@emotion/react'
import { FC } from 'react'
import { Wrapper } from './styles'

interface IProps {
  text: string
  withIcon?: boolean
  marginTop?: number
}

const ErrorText: FC<IProps> = ({ text, withIcon = true, marginTop }) => {
  const theme = useTheme()

  return withIcon ? (
    <Wrapper marginTop={marginTop}>
      <IconErrorOutline size="xsmall" colorVariant="error" />
      <Text semibold color={theme.alert} size="14px">
        {text}
      </Text>
    </Wrapper>
  ) : (
    <Text semibold color={theme.alert} size="14px">
      {text}
    </Text>
  )
}

export default ErrorText
